import { websocketService } from './websocketService';
import { audioCaptureService } from './audioCaptureService';
import { recallWebSocketService } from './recallWebSocketService';
import { landmineWebSocketService } from './landmineWebSocketService';
import { competitorWebSocketService } from './competitorWebSocketService';

class CleanupService {
  private isCleanupRegistered = false;

  registerCleanupHandlers() {
    if (this.isCleanupRegistered) {
      return;
    }

    console.log('🧹 Registering cleanup handlers for page/tab close');

    // Handle page unload (browser close, tab close, refresh)
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    // Handle visibility change (tab switch, minimize)
    // document.addEventListener('visibilitychange', this.handleVisibilityChange);
    
    // Handle page hide (mobile/browser-specific)
    window.addEventListener('pagehide', this.handlePageHide);

    this.isCleanupRegistered = true;
  }

  private handleBeforeUnload = (event: BeforeUnloadEvent) => {
    console.log('🧹 Page is being unloaded - performing cleanup');
    this.performCleanup();
    
    // Don't show confirmation dialog for normal cleanup
    // event.preventDefault();
    // event.returnValue = '';
  };

  private handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      console.log('🧹 Page visibility changed to hidden - performing cleanup');
      this.performCleanup();
    }
  };

  private handlePageHide = (event: PageTransitionEvent) => {
    console.log('🧹 Page hide event - performing cleanup');
    this.performCleanup();
  };

  private performCleanup() {
    try {
      console.log('🧹 Starting comprehensive cleanup...');

      // Stop audio capture first
      if (audioCaptureService.isCapturing()) {
        console.log('🎧 Stopping audio capture...');
        audioCaptureService.stopCapture();
      }

      // Disconnect ALL WebSocket services
      console.log('🔌 Disconnecting all WebSocket services...');
      websocketService.disconnect();
      recallWebSocketService.disconnect();
      landmineWebSocketService.disconnect();
      competitorWebSocketService.disconnect();

      console.log('✅ Cleanup completed - all services disconnected');
    } catch (error) {
      console.error('❌ Error during cleanup:', error);
    }
  }

  // Method to manually trigger cleanup (for disconnect button)
  manualCleanup() {
    console.log('🧹 Manual cleanup triggered');
    this.performCleanup();
  }

  unregisterCleanupHandlers() {
    if (!this.isCleanupRegistered) {
      return;
    }

    console.log('🧹 Unregistering cleanup handlers');
    
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('pagehide', this.handlePageHide);
    
    this.isCleanupRegistered = false;
  }
}

export const cleanupService = new CleanupService();